import type Wei from '@kwenta/wei'
import { type FC, memo } from 'react'
import styled from 'styled-components'

import type { CrossMarginRiskStatus } from 'state/futures/common/types'

type Props = {
	ratio: Wei
	risk: CrossMarginRiskStatus
}

const MarginRatioBarChart: FC<Props> = memo(({ ratio, risk }) => {
	return (
		<MarginRatioBarContainer>
			<MarginRatioBar $ratio={Number(ratio)} $risk={risk} />
		</MarginRatioBarContainer>
	)
})

const MarginRatioBarContainer = styled.div`
	height: 6px;
	border-radius: 2px;
	background: linear-gradient(90deg, #024d00 0%, #4d0000 100%);
	width: 100%;
`

const MarginRatioBar = styled.div<{ $ratio: number; $risk: CrossMarginRiskStatus }>`
	height: 6px;
	border-radius: 2px;
	width: ${({ $ratio }) => `${$ratio * 100}%`};
	background: ${(props) =>
		props.$risk
			? props.theme.colors.selectedTheme.newTheme.riskStatus[props.$risk]
			: props.theme.colors.selectedTheme.newTheme.border.color};
	}
`

export default MarginRatioBarChart
